export const HOME = process.env.REACT_APP_HOME 
export const API_AUTH = process.env.REACT_APP_CAN_AUTH_API || "https://apidev.growthgamut.com/pieiamapi"

export const API_CANDIDATE = process.env.REACT_APP_CANDIDATE_API || "https://apidev.growthgamut.com/ggcanapi"

export const EMP = process.env.REACT_APP_EMP 

// export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY 

export const RS_API = process.env.REACT_APP_RS_API || "https://apidev.growthgamut.com/ggrsapi"

export const HCM_API = process.env.REACT_APP_HCM_API  


export const DATE_FORMAT = "DD-MM-YYYY"
export const DATE_FORMAT_INPUT = "YYYY-MM-DD"


